import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useArchiveCategory(id) {
  const queryClient = useQueryClient()

  const action = async () => {
    return await httpClient.post(`team/transaction-category/${id}/archive`)
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: () => {
      toast.success('Category archived successfully')
      queryClient.invalidateQueries({ queryKey: ['archive-category'] })
      queryClient.invalidateQueries({ queryKey: ['transaction-categories'] })
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
